function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Stack, RangeSelector } from 'grommet';
const RangeInput = ({
  direction,
  options,
  value,
  handleOnChange,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(Box, {
    direction: direction === 'vertical' ? 'column' : 'row',
    justify: "between"
  }, options.map(option => /*#__PURE__*/React.createElement(Box, {
    key: option,
    pad: "small",
    border: false,
    flex: {
      shrink: 0
    }
  }, /*#__PURE__*/React.createElement(Text, null, option)))), /*#__PURE__*/React.createElement(RangeSelector, _extends({
    direction: direction || 'horizontal',
    invert: false,
    min: options[0],
    max: options[options.length - 1],
    size: "full",
    round: "small",
    values: value || [options[0]],
    onChange: values => handleOnChange(values)
  }, rest)));
};
RangeInput.propTypes = {
  direction: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.any,
  handleOnChange: PropTypes.func
};
export default RangeInput;